/**
 * Action Types
 */

export const Types = {
    SELECT_DEPARTAMENTO: 'departamento/SELECT_DEPARTAMENTO',
    DESELECT_DEPARTAMENTO: 'departamento/DESELECT_DEPARTAMENTO'
};

/**
 * Reducer
 */

const INITIAL_STATE = {};

export default function departamentoSelecionado(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.SELECT_DEPARTAMENTO:
            return { ...state, ...action.payload };

        case Types.DESELECT_DEPARTAMENTO:
            return { ...INITIAL_STATE };

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    selectDepartamento: (payload) => ({
        type: Types.SELECT_DEPARTAMENTO,
        payload
    }),
    deselectDepartamento: () => ({
        type: Types.DESELECT_DEPARTAMENTO
    })
};
